/**
 * Frontend-only persona preview persistence (Epic 22).
 */
import { isValidPersonaPresetId } from './personaPresets';

export const PREVIEW_PERSONA_STORAGE_KEY = 'warehouse.personaPreview.presetId';

/**
 * Production: enable only when REACT_APP_ENABLE_PERSONA_PREVIEW is explicitly true.
 * Non-production: enabled unless explicitly set to false/0/no.
 */
export function isPersonaPreviewFeatureEnabled(): boolean {
  const v = String(process.env.REACT_APP_ENABLE_PERSONA_PREVIEW || '').trim().toLowerCase();
  if (v === 'true' || v === '1' || v === 'yes') return true;
  if (v === 'false' || v === '0' || v === 'no') return false;
  return process.env.NODE_ENV !== 'production';
}

export function readStoredPreviewPersonaId(): string | null {
  try {
    const raw = localStorage.getItem(PREVIEW_PERSONA_STORAGE_KEY);
    const id = String(raw || '').trim();
    if (!id || !isValidPersonaPresetId(id)) return null;
    return id;
  } catch {
    return null;
  }
}

export function writeStoredPreviewPersonaId(id: string | null): void {
  try {
    if (!id) {
      localStorage.removeItem(PREVIEW_PERSONA_STORAGE_KEY);
      return;
    }
    if (!isValidPersonaPresetId(id)) {
      localStorage.removeItem(PREVIEW_PERSONA_STORAGE_KEY);
      return;
    }
    localStorage.setItem(PREVIEW_PERSONA_STORAGE_KEY, id);
  } catch {
    // ignore
  }
}

export function clearStoredPreviewPersona(): void {
  try {
    localStorage.removeItem(PREVIEW_PERSONA_STORAGE_KEY);
  } catch {
    // ignore
  }
}
